import styled from 'styled-components';

export const LogoName = styled.span`
  font-family: 'Roboto';
  font-size: 26px;
  line-height: 30px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  flex-grow: 1;

  color: #FFFFFF;

  opacity: 0.6;
`;